import { APP_NAME } from '@/constants';
import Image from 'next/image';
import React from 'react';

/**
 * Component that renders the FieldOne logo for printing purposes. It is
 * displayed only when the `isPrinting` prop is true.
 */
export const PrintLogo: React.FC<{ isPrinting: boolean }> = ({ isPrinting }) => {
  // If not in printing mode, do not render anything
  if (!isPrinting) return null;

  // Render the FieldOne logo centered on the page when printing
  return (
    <div className="mb-8 mt-4 flex w-full items-center justify-center">
      <Image
        src="/logos/fieldone_logo.svg"
        alt={`${APP_NAME} Logo`}
        width={200}
        height={60}
        style={{ height: 60, width: 200 }}
        priority={true}
      />
    </div>
  );
};

PrintLogo.displayName = 'PrintLogo';

export default PrintLogo;
